// Permission keys (plan 7.2: 35 keys in 6 bundles) as listed in the mockup data.js.
// PROVISIONAL: packages/contracts will own the permission catalog — replace this file with the contracts export then.

export const PERM_BUNDLE_IDS = ["usage","records","content","work","export","admin"] as const;
export type PermBundleId = (typeof PERM_BUNDLE_IDS)[number];

export interface PermKeyInfo {
  key: string;
  bundle: PermBundleId;
  /** Opening someone else's text/work detail goes through the fixed access flow (reason → re-login → 60 min grant). */
  flow: boolean;
  /** Widening it needs two-person approval. */
  dualApproval: boolean;
}

export const PERM_KEYS: readonly PermKeyInfo[] = [
  { key: "usage.view", bundle: "usage", flow: false, dualApproval: false },
  { key: "cost.view", bundle: "usage", flow: false, dualApproval: false },
  { key: "stats.view", bundle: "usage", flow: false, dualApproval: false },
  { key: "logs.list", bundle: "records", flow: false, dualApproval: false },
  { key: "people.view", bundle: "records", flow: false, dualApproval: false },
  { key: "people.identity", bundle: "records", flow: false, dualApproval: true },
  { key: "people.individual", bundle: "records", flow: false, dualApproval: true },
  { key: "logs.prompt", bundle: "content", flow: true, dualApproval: true },
  { key: "logs.answer", bundle: "content", flow: true, dualApproval: true },
  { key: "logs.files", bundle: "work", flow: true, dualApproval: true },
  { key: "logs.diff", bundle: "work", flow: true, dualApproval: true },
  { key: "logs.commands", bundle: "work", flow: true, dualApproval: true },
  { key: "logs.tool_output", bundle: "work", flow: true, dualApproval: true },
  { key: "logs.raw", bundle: "work", flow: true, dualApproval: true },
  { key: "export.aggregate", bundle: "export", flow: false, dualApproval: false },
  { key: "export.rows", bundle: "export", flow: false, dualApproval: true },
  { key: "export.identity", bundle: "export", flow: false, dualApproval: true },
  { key: "export.content", bundle: "export", flow: false, dualApproval: true },
  { key: "people.manage", bundle: "admin", flow: false, dualApproval: false },
  { key: "teams.manage", bundle: "admin", flow: false, dualApproval: false },
  { key: "roles.manage", bundle: "admin", flow: false, dualApproval: false },
  { key: "policy.manage", bundle: "admin", flow: false, dualApproval: false },
  { key: "notice.manage", bundle: "admin", flow: false, dualApproval: false },
  { key: "integrations.manage", bundle: "admin", flow: false, dualApproval: false },
  { key: "keys.view", bundle: "admin", flow: false, dualApproval: false },
  { key: "devices.revoke_any", bundle: "admin", flow: false, dualApproval: false },
  { key: "budget.manage", bundle: "admin", flow: false, dualApproval: false },
  { key: "deletion.process", bundle: "admin", flow: false, dualApproval: false },
  { key: "legal_hold.manage", bundle: "admin", flow: false, dualApproval: false },
  { key: "access.approve", bundle: "admin", flow: false, dualApproval: false },
  { key: "audit.view", bundle: "admin", flow: false, dualApproval: false },
  { key: "audit.verify", bundle: "admin", flow: false, dualApproval: false },
  { key: "retention.manage", bundle: "admin", flow: false, dualApproval: false },
  { key: "glossary.edit", bundle: "admin", flow: false, dualApproval: false },
  { key: "system.view", bundle: "admin", flow: false, dualApproval: false },
];

export type PermKey = string;
